import { render, staticRenderFns } from "./AssignmentDeviceHistory.vue?vue&type=template&id=553a9a2d"
import script from "./AssignmentDeviceHistory.vue?vue&type=script&lang=js"
export * from "./AssignmentDeviceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports